import { useState } from "react";
import { Link } from "react-router-dom";
import api, { formatApiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { AuthShell } from "@/components/AuthShell";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [msg, setMsg] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault(); setError(""); setLoading(true);
    try { const { data } = await api.post("/auth/forgot-password", { email }); setMsg(data.message); }
    catch (err) { setError(formatApiError(err.response?.data?.detail) || err.message); }
    finally { setLoading(false); }
  };

  return (
    <AuthShell caption="Glemt adgangskode" title="Nulstil din adgangskode">
      {msg ? (
        <div className="space-y-5">
          <p className="text-sm text-stone-700 rounded-xl border border-[#D3D8C6] bg-[#F3F6EE] p-4" data-testid="forgot-done">{msg}</p>
          <Link to="/login" className="text-sm text-[#A83232] hover:underline font-medium" data-testid="forgot-back">Tilbage til login</Link>
        </div>
      ) : (
        <form onSubmit={submit} className="space-y-5">
          <p className="text-sm text-stone-500 -mt-5">Indtast din e-mail, så sender vi et link til at vælge en ny adgangskode.</p>
          <div className="space-y-2">
            <Label htmlFor="email" className="text-sm font-medium text-stone-700">Email</Label>
            <Input id="email" data-testid="forgot-email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="navn@bsm.dk" required className="h-11 rounded-xl bg-white" />
          </div>
          {error && <p data-testid="forgot-error" className="text-sm text-destructive font-medium">{error}</p>}
          <Button data-testid="forgot-submit" type="submit" disabled={loading} className="w-full rounded-xl h-11 font-semibold text-[15px]">{loading ? "Sender…" : "Send link"}</Button>
          <Link to="/login" className="block text-sm text-stone-500 hover:text-stone-900" data-testid="forgot-back">← Tilbage til login</Link>
        </form>
      )}
    </AuthShell>
  );
}
